module.exports = __webpack_public_path__ + "static/media/book2.6b64a332.jpg";